import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Table from '../../components/knowledges/Table/Table';
import StyledButton from '../../components/shared/Button/StyledButton';
import Page from '../../components/shared/Page/Page';
import StyledTable from '../../components/shared/Table/StyledTable';
import StyledTableHeader from '../../components/shared/Table/StyledTableHeader';
import AuthContext from '../../contexes/AuthContext';
import { canPerformAction, PERMISSIONS } from '../../utils/permissions';

const Knowledges: React.FC = () => {
  const { t } = useTranslation();
  const { currentUser } = useContext(AuthContext);

  return (
    <Page title="Elora | Knowledges">
      <StyledTable>
        <StyledTableHeader>
          <h1>{t('Knowledges')}</h1>
          {currentUser &&
            canPerformAction(currentUser, PERMISSIONS.MANAGE_KNOWLEDGE) && (
              <Link to="/knowledges/new">
                <StyledButton variant="contained" color="primary" size="small">
                  {t('New Knowledge')}
                </StyledButton>
              </Link>
            )}
        </StyledTableHeader>
        <Table />
      </StyledTable>
    </Page>
  );
};

export default Knowledges;
